import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// This component is used to display the circular progress in Sidebar
const CircularProgressWithLabel = ({ value, onClick }) => {

  if(value === 100){
    return null;
  }
  return (
    <Box
      data-testid="setup-progress-ring"
      sx={{
        width: 64, // Fits perfectly in 80px sidebar (with 8px padding)
        minHeight: 100,
        height: 'auto',
        bgcolor: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: "8px 6px",
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        borderRadius: '6px',
        gap:"1px"
      }}
      onClick={onClick}
    >
      {/* Circular progress with percentage */}
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 44,
          height: 44,
        }}
      >
        {/* Background circle */}
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{
            color: '#e0e0e0',
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}
          thickness={4}
        />
        {/* Progress circle */}
        <CircularProgress
          variant="determinate"
          value={value}
          sx={{
            color: '#4CAF50',
            position: 'absolute',
            width: '100%',
            height: '100%',
            transition: 'all 0.3s ease',
          }}
          thickness={4}
        />
        {/* Percentage label */}
        <Typography
          variant="caption"
          fontWeight="bold"
          sx={{
            fontSize: '0.65rem',
            color: '#000',
          }}
        >
          {`${value}%`}
        </Typography>
      </Box>

      {/* Text below circular progress */}
      <Typography
        sx={{
          fontSize: '11px',
          color: '#301B72',
          mt: 0.5,
          textAlign: 'center',
          fontFamily: "IBM Plex Sans",
          fontWeight: "500",
          lineHeight: 1.2,
        }}
      >
        Setup Progress
      </Typography>
    </Box>
  );
};

export default CircularProgressWithLabel;
